import { render, staticRenderFns } from "./MingXi.vue?vue&type=template&id=0bbe161e&scoped=true"
import script from "./MingXi.vue?vue&type=script&lang=js"
export * from "./MingXi.vue?vue&type=script&lang=js"
import style0 from "./MingXi.vue?vue&type=style&index=0&id=0bbe161e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbe161e",
  null
  
)

export default component.exports